(function () {
  if (!location.pathname.startsWith('/zh')) return;

  const colorMapping = {
  "aquamarine": "海鸥灰",
  "almond": "杏仁色",
  "agarwood": "沉香棕",
  "amber": "燕麦棕",
  "amber-old-version": "琥珀棕",
  "black": "黑色",
  "brandy": "棠梨色",
  "burgundy": "勃艮第红",
  "burgundy-red": "勃艮第红",
  "canvas": "茶叶棕",
  "caramel": "焦糖棕",
  "celeste": "盐湖蓝",
  "chocolate": "暮棕色",
  "chocolate-old-version": "暮棕色",
  "chestnut-suede": "栗木棕",
  "chestnut": "栗木棕",
  "celadon": "浅草绿",
  "cloud": "余墨白",
  "cobble": "风衣灰",
  "cobble-old-version": "风衣灰",
  "cobble-grain": "风衣灰",
  "cocoa-mocha": "可可摩卡",
  "coral": "蜜桃粉",
  "cream-apricot": "奶杏色",
  "creamy-white": "奶昔白",
  "citrine": "金运黄",
  "cypress": "苍绿色",
  "dawn": "晨白",
  "denim": "牛仔蓝",
  "dune-suede": "沙驼棕",
  "drab": "松木棕",
  "eco-caramel": "火山棕",
  "eco-cloud": "云朵白",
  "eco-ivory": "云朵白",
  "eco-onyx": "烟墨黑",
  "eco-taupe": "大象灰",
  "emerald": "松木绿",
  "emerald-old-version": "松木绿",
  "ebony": "黑檀色",
  "forest": "雪松绿",
  "ginger": "姜黄色",
  "gold": "金色",
  "golden": "金色",
  "golden-brown": "金棕色",
  "graphite": "锡器灰",
  "grey": "灰色",
  "haze": "云幕灰",
  "honey": "蜜蜡黄",
  "ivory": "茯苓白",
  "ivory-old-version": "茯苓白",
  "ivory-cream-apricot": "茯苓白&奶杏色",
  "jade": "青石绿",
  "jade-old-version": "青石绿",
  "khaki": "卡其色",
  "lavender": "豆蔻紫",
  "lavender-old-version": "豆蔻紫",
  "lavender-purple": "豆蔻紫",
  "lemon": "鹅梨黄",
  "lemonade": "柠檬黄",
  "limestone": "薄墨灰",
  "lucky-red": "开运红",
  "lucky-red-old-version": "开运红",
  "maroon": "海棠红",
  "mango-yellow": "芒果黄",
  "matcha": "抹茶绿",
  "mint-green": "薄荷绿",
  "mint-green-old-version": "薄荷绿",
  "mocha": "枇杷棕",
  "mocha-old-version": "枇杷棕",
  "moonstone": "净念白",
  "moss": "松苔绿",
  "moss-green": "苔藓绿",
  "navy": "海雾蓝",
  "nightfall": "暮棕色",
  "oat": "杏仁黄",
  "olive": "橄榄绿",
  "olivine": "慧心绿",
  "olive-suede": "苍漠绿",
  "ochre-suede": "沙暮棕",
  "onyx": "烟墨黑",
  "onyx-grain": "烟墨黑",
  "onyx-old-version": "烟墨黑",
  "ochre": "沙暮棕",
  "oolong": "乌龙色",
  "orange": "活力橙",
  "peach": "柔和桃",
  "peacock-blue": "孔雀蓝",
  "pearl-grey": "珍珠灰",
  "pink": "果冻粉",
  "placid-blue": "冰青蓝",
  "poppy": "辣椒红色",
  "purple": "紫色",
  "raisin": "红陶棕",
  "red": "红色",
  "red-with-printed": "红色花纹",
  "rose": "蔷薇玫瑰",
  "sage": "烟波翠",
  "sandal": "檀棕色",
  "sandal-suede": "檀棕色（麂皮）",
  "sandal-ochre": "檀棕/沙砾黄撞色",
  "sandal-camel": "檀棕/驼色撞色",
  "sandalwood": "木檀色",
  "sea-buckthorn": "沙棘棕",
  "stardust": "瓦砾灰",
  "sky": "水雾蓝",
  "sky-old-version": "水雾蓝",
  "taro": "香芋紫",
  "taupe": "大象灰",
  "taupe-old-version": "大象灰",
  "turtle": "海龟",
  "topaz": "月光黄",
  "tranquil-blue": "宁静蓝",
  "turtledove-grey": "斑鸠灰",
  "vanilla": "米白色",
  "veri-peri": "长春花蓝",
  "very-peri": "长春花蓝",
  "walnut": "陶土棕",
  "walnut-old-version": "陶土棕",
  "white": "白色",
  "whale": "鲸鱼",
  "yellow": "黄色",
  "onyx-medium": "烟墨黑中号",
  "onyx-large": "烟墨黑大号",
  "onyx-silver-tone-hardware": "烟墨黑（白钢五金）",
  "one-size": "仅一个尺寸",
  "large": "大号",
  "small": "小号",
  "songmont-golden-pine-club": "付费会员",
  "umber": "禅棕褐",
  "midnight": "静夜蓝",
  "sulfur": "石窟黄",
  "dark-brown": "深咖色",
  "smoke-grey": "松烟灰"
};

  const translatedItems = new WeakSet();

  function getHandleFromLink(link) {
    if (!link || !link.href || !link.href.includes('/products/')) return null;

    return link.href
      .split('/products/')[1]
      .split('?')[0]
      .split('#')[0];
  }

  function getVariantIdFromItem(item) {
    return item.getAttribute('data-gw-variant-id');
  }

  function normalizeKey(text) {
    return text
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-');
  }

  async function fetchProductJson(handle) {
    const response = await fetch(`/zh/products/${handle}.js`);

    if (!response.ok) {
      throw new Error(`Product JSON fetch failed: ${handle}`);
    }

    return response.json();
  }

  async function translateItem(item) {
    if (translatedItems.has(item)) return;

    const titleLink = item.querySelector('.gw-wl-page-item__title');
    if (!titleLink) return;

    const handle = getHandleFromLink(titleLink);
    if (!handle) return;

    translatedItems.add(item);

    try {
      const product = await fetchProductJson(handle);

      if (product.title) {
        titleLink.textContent = product.title;

        const imageLink = item.querySelector('.gw-wl-page-item__image');
        if (imageLink) {
          imageLink.setAttribute('aria-label', product.title);
        }

        const image = item.querySelector('.gw-image__img');
        if (image) {
          image.setAttribute('alt', product.title);
        }
      }

      item.querySelectorAll('.gw-wl-page-item__options-item-name').forEach((el) => {
        const text = el.textContent.trim();

        if (text === 'Color:' || text === 'Color') {
          el.textContent = '颜色：';
        }
      });

      item.querySelectorAll('.gw-wl-page-item__options-item-value').forEach((el) => {
        const key = normalizeKey(el.textContent);

        if (colorMapping[key]) {
          el.textContent = colorMapping[key];
        }
      });
    } catch (error) {
      translatedItems.delete(item);
      console.warn('[Growave Translate]', error);
    }
  }

  function translateWishlist() {
    document
      .querySelectorAll('[data-gw-selector="wishlist-item"]')
      .forEach((item) => {
        translateItem(item);
      });
  }

  translateWishlist();

  const observer = new MutationObserver(() => {
    translateWishlist();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();